import { render, staticRenderFns } from "./toplu-sms.vue?vue&type=template&id=78252d9d&scoped=true&"
import script from "./toplu-sms.vue?vue&type=script&lang=js&"
export * from "./toplu-sms.vue?vue&type=script&lang=js&"
import style0 from "./toplu-sms.vue?vue&type=style&index=0&id=78252d9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78252d9d",
  null
  
)

export default component.exports